import { apiClient } from "../lib/api";

export const noticeApi = {
  generate: (payload) => apiClient.post("/notices", payload),
  getCurrentByEmployee: (employeeId) => apiClient.get(`/notices/by-employee/${employeeId}`),
  listVersions: (employeeId) => apiClient.get(`/notices/by-employee/${employeeId}/versions`),
  get: (id) => apiClient.get(`/notices/${id}`),
  updateDraft: (id, payload) => apiClient.patch(`/notices/${id}`, payload),
  approve: (id) => apiClient.post(`/notices/${id}/approve`),
  issue: (id) => apiClient.post(`/notices/${id}/issue`),
  sign: (id, typed_name) => apiClient.post(`/notices/${id}/sign`, { typed_name }),
  uploadSignedScan: (id, file) => {
    const form = new FormData();
    form.append("file", file);
    return apiClient.post(`/notices/${id}/upload-signed-scan`, form, { headers: { "Content-Type": "multipart/form-data" } });
  },
};
